import React from "react";
import SelectCoachInput from "../../../components/inputs/coach/selectCoachInput";
import { AppointmentOverviewContext } from "../context/appointmentOverviewContext";
import SearchControllsProps from "../interface/searchControllsProps";

const CoachSelect = (): React.JSX.Element => {
  const {
    searchControlls,
    setSearchControlls,
  }: {
    searchControlls: SearchControllsProps;
    setSearchControlls: React.Dispatch<
      React.SetStateAction<SearchControllsProps>
    >;
  } = React.useContext(AppointmentOverviewContext);

  const handleSetCoach = (
    coach: { label: string; value: string | null } | null
  ): void => {
    setSearchControlls({
      ...searchControlls,
      coach,
    });
  };

  return (
    <SelectCoachInput
      disabled={searchControlls.loading}
      coach={searchControlls.coach}
      setCoach={handleSetCoach}
    />
  );
};

export default CoachSelect;
